import { STORAGE_KEYS } from './DICTIONARY';
import localStore from './localStore';

function isLoggedIn() {
  const wasLoggedIn = localStore.get(STORAGE_KEYS.LOGGED_IN_STORE_NAME);
  if (!wasLoggedIn) {
    logout();
  }
  return wasLoggedIn;
}

function set(data) {
  return localStore.put(STORAGE_KEYS.USER_DATA, data);
}

function get() {
  const data = localStore.get(STORAGE_KEYS.USER_DATA);
  return data ? JSON.parse(data) : null;
}

function isPasswordChangeRequired() {
  const data = localStore.get(STORAGE_KEYS.PASSWORD_CHANGE_REQUIRED);
  return data ? JSON.parse(data) : null;
}

function logout() {
  Object.keys(STORAGE_KEYS).forEach(key => localStore.clear(STORAGE_KEYS[key]));
  // localStore.clear('fromLogin');
  localStore.clear('syncStatus');
  localStore.clear('configuration');
  localStore.clear('accessBlocked');
  localStore.clear('appLevelAlert');
  localStore.clear('storeProperties');
  localStore.clear('subscriptionDetails');
  localStore.clear('onboarding_completed');

  localStore.clear('customerPortalDomains');
  localStore.clear('emailSettingsDefaults');
  localStore.clear('setupCheckListComplete');
  localStore.clear('overview_metrics_since');
  localStore.clear('rr__last-quota-exhaust-reminder-date');
  localStore.clear('dashboard_analytics_units');
  localStore.clear('dashboard_analytics_dateRange');
  localStore.clear('insights_analytics_product');
  localStore.clear('insights_analytics_dateRange');
  localStore.clear('state-os-init');
  localStore.clear('OrderService_ProductCatalog__searchStates');
  localStore.clear('insights_analytics_productVsRequestReasonsType');
  localStore.clear('rr-requests-filters');
  localStore.clear('rr-orders-filters');
}

export default {
  isLoggedIn,
  logout,
  get,
  set,
  isPasswordChangeRequired
};
